<template>
  <div>
    <!-- DELETE WARNING -->
    <v-dialog v-model="showDialog" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-card-title>
          {{ $t('message.common.deleteConfirm') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          {{ $t('message.common.areYouSure') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" id="deleteConfirm" :loading="loading" @click="confirmDelete">{{ $t('message.common.yes')
            }}</v-btn>
          <v-btn color="primary" id="deleteClose" @click="showDialog = false">{{ $t('message.common.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- DELETE WARNING  -->
    <v-bottom-navigation app :dark="appDark" :class="['small_device_custom_spacing', bottomNavClass]" max-width="1264px"
      :style="`left: ${bottomNavigationLeftValue}px !important;`">
      <div class="d-flex">
        <template v-for="(button, index) in getMenuLinks">
          <v-btn class="fixbuttondesign" v-if="button.isShow !== undefined ? button.isShow : true"
            :key="`${index}_menu_navigation`" icon small :style="`color: ${navItemColor} !important;`" :to="button.to">
            <span>{{ $t(button.text) }}</span>
            <v-icon>{{ button.icon }}</v-icon>
          </v-btn>
        </template>
        <v-menu offset-y top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="btnmsgbox" v-bind="attrs" icon v-on="on" small :style="`color: ${navItemColor} !important;`">
              <span class="moretextmsg">{{ $t('message.layout.more') }}</span>
              <v-icon :dark="appDark">mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>
          <v-list>
            <span class="overflow-text pl-3 font-weight-medium">{{ userDetails.name }}</span>
            <v-divider></v-divider>
            <!-- global light/dark theme toggle, available from every page -->
            <v-list-item dense @click.stop>
              <v-list-item-title :style="{ 'line-height': '3' }">
                <v-icon small class="mr-1">{{ appDark ? 'mdi-weather-night' : 'mdi-weather-sunny' }}</v-icon>
                {{ $t('message.dashboard.darkMode') }}
              </v-list-item-title>
              <v-switch class="v-icon mb-n4 mt-0 ml-2" :input-value="appDark" @click.stop @change="toggleAppTheme"></v-switch>
            </v-list-item>
            <!-- Edit dashboard: only on the dashboard, replaces the old top Edit button -->
            <v-list-item dense v-if="$route.path === '/dashboard'" @click="editDashboard">
              <v-list-item-title :style="{ 'line-height': '3' }">
                <v-icon small class="mr-1">mdi-pencil</v-icon>
                {{ $t('message.dashboard.edit') }}
              </v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item dense v-for="(item, index) in menuItems" :key="index" @click="menuActions(item.click, item.value)">
              <v-list-item-title :style="{ 'line-height': '3'}" v-if="item.value !== 'autoLogout'">
                {{ $t(item.title) }}
              </v-list-item-title>
              <template v-else>
                <v-list-item-title :style="{ 'line-height': '3'}" @click.stop>{{ $t(item.title) }}</v-list-item-title>
                <v-switch class="v-icon mb-n4 mt-0 ml-2" color="#000" v-model="switchValue" @click.stop @change="handleSwitchChange($event)"></v-switch>
              </template>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-bottom-navigation>

    <!-- DIALOG TO CONFIRM // CANCEL -->
    <v-dialog v-model="showConfirmationDialog" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-card-title>
          {{ $t(confirmationPayload.title) }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          {{ $t(confirmationPayload.text) }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" id="confirmToProceed" :loading="loading" @click="confirmProceed">{{
            $t('message.common.yes') }}</v-btn>
          <v-btn color="error" id="cancelProceed" @click="showConfirmationDialog = false">{{ $t('message.common.no')
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- DIALOG TO CONFIRM // CANCEL -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FeaturesMixin from '@/mixins/features_list'
import { hostAppApi } from '../plugins/axios_settings'
import { toggleTheme } from '@/utils/theme'

export default {
  mixins: [FeaturesMixin],
  data () {
    return {
      loading: false,
      menuLinks: [
        { name: 'calendar', icon: 'mdi-plus', to: '/calendar/actions', text: 'message.timer.hours' },
        { name: 'calendar', icon: 'mdi-calendar', to: '/calendar', text: 'message.layout.calendar' },
        { name: 'dashboard', icon: 'mdi-home', to: '/dashboard', text: 'message.layout.dashboard' },
        { name: 'files', icon: 'mdi-file', to: '/files', text: 'message.layout.files' }
      ],
      switchValue: false,
      intervalId: null,
      deliveryLoading: false,
      bottomNavigationLeftValue: 0
    }
  },
  computed: {
    ...mapGetters(['showDialog', 'userDetails', 'deletePayload', 'getuserDetails', 'showConfirmationDialog', 'confirmationPayload', 'getHostRefApi']),
    // bottom nav follows the global app theme: a light surface with blue icons
    // in light mode, a dark dashboard-matching surface with white icons in dark.
    appDark () {
      return this.$vuetify.theme.dark
    },
    bottomNavClass () {
      return this.appDark ? 'dash-bottom-nav--dark' : 'dash-bottom-nav'
    },
    // icon/label colour: theme blue on the light bar, white on the dark bar.
    navItemColor () {
      return this.appDark ? '#ffffff' : '#1f6feb'
    },
    getMenuLinks () {
      const listitems = []
      this.menuLinks.forEach(item => {
        if (this.checkFeatureEnabled(item.name)) listitems.push(item)
      })
      return listitems
      /* const layoutMenuItems = this.$formatter.cloneVariable(this.menuLinks)
      if (this.$store.state.common.isCalendarFormExcluded) layoutMenuItems.splice(0, 1)
      return layoutMenuItems */
    },
    showDialog: {
      get () {
        return this.$store.state.common.showDialog
      },
      set (val) {
        if (!val) this.$store.commit('hideDialog')
      }
    },
    showConfirmationDialog: {
      get () {
        return this.$store.state.common.showConfirmationDialog
      },
      set (val) {
        if (!val) this.$store.commit('hideConfirmationDialog')
      }
    },
    menuItems () {
      const languages = [
        { title: 'message.common.english', value: 'en', click: 'language' },
        { title: 'message.common.norwegian', value: 'no', click: 'language' },
        { title: 'message.common.lithuanian', value: 'lt', click: 'language' },
        { title: 'message.common.polish', value: 'pl', click: 'language' },
        { title: 'message.common.swedish', value: 'sv', click: 'language' }
      ]
      const languageIndex = languages.findIndex(x => x.value === this.$i18n.locale)
      languages.splice(languageIndex, 1)
      languages.push({ title: 'message.layout.autoLogout', value: 'autoLogout' }, { title: 'message.layout.logout', click: 'logout' })
      return languages
      /* let language
      if (this.$i18n.locale === 'en') {
        language = { title: 'message.common.norwegian', value: 'no', click: 'language' }
      } else if (this.$i18n.locale === 'no') language = { title: 'message.common.english', value: 'en', click: 'language' }
      const items = [language, { title: 'message.layout.logout', click: 'logout' }]
      return items */
    }
  },
  created () {
    /* since this is called every reload, adding the commit of isprojectexcluded and isdeviationexcluded here itself */
    this.$store.commit('isProjectExcluded', this.getFeatureObj('projects') ? !this.getFeatureObj('projects').enabled : false)
    window.addEventListener('resize', () => {
      if (window.innerWidth > 1262) {
        this.bottomNavigationLeftValue = (window.innerWidth - 1262) / 2
      } else this.bottomNavigationLeftValue = 0
    })
    if (this.$vuetify.breakpoint.mdAndUp) this.bottomNavigationLeftValue = (window.innerWidth - 1262) / 2
  },
  methods: {
    // flip the global app theme from the nav menu (works on every page)
    toggleAppTheme () { toggleTheme(this.$vuetify) },
    // enter dashboard edit mode (the dashboard listens for this) — replaces the
    // old top Edit button
    editDashboard () { this.$root.$emit('enterDashboardEdit') },
    menuActions (action, value) {
      switch (action) {
        case 'logout':
          this.$store.dispatch('logout')
          this.$router.push('/login')
          break
        case 'language':
          this.changeLang(value)
          break
        default:
          break
      }
    },
    changeLang (language) {
      this.$i18n.locale = language
      window.localStorage.setItem(process.env.VUE_APP_LOCALE_STORAGE, language)
    },
    confirmDelete () {
      this.loading = true
      const model = this.deletePayload
      if (model.isDocumentDelete) {
        this.$eventBus.$emit('deleteSuccess', model)
        this.loading = false
      } else if (model.isSingle) {
        this.$store.dispatch('deleteSingleRecordHandler', model)
          .then(() => {
            this.$eventBus.$emit('deleteSuccess', model.module)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.$store.dispatch('deleteHandler', model)
          .then(() => {
            this.$eventBus.$emit('deleteSuccess', model.module)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    confirmProceed () {
      this.loading = true
      const model = this.confirmationPayload
      this.$eventBus.$emit('confirmedToProceed', model.module, model.saveData)
      setTimeout(() => {
        this.loading = false
      }, 50)
    },
    handleSwitchChange (e) {
      const UserRole = localStorage.getItem('UserRole')
      const parsedData = JSON.parse(UserRole)
      const body = {
        auto_logout_enabled: e,
        user_id: parsedData?.pivot?.user_id
      }
      hostAppApi.post(`${this.getHostRefApi}automatic-logout`, body)
        .then((response) => {
          this.switchValue = response?.data?.auto_logout_enabled
          if (response?.data?.auto_logout_enabled) {
            this.startInactivityTimer() // start inactivity timer
          } else {
            this.stopInactivityTimer() // stop inactivity timer
          }
        })
        .catch((error) => {
          console.log('error', error?.data?.message)
        })
    },
    automaticLogoutGet () {
      hostAppApi.get(`${this.getHostRefApi}automatic-logout`)
        .then((response) => {
          this.switchValue = response?.data?.auto_logout_enabled
          if (response?.data?.auto_logout_enabled) {
            this.startInactivityTimer() // start inactivity timer
          } else {
            this.stopInactivityTimer() // stop inactivity timer
          }
        })
    },
    startInactivityTimer () {
      this.intervalId = setInterval(() => {
        const lastActivity = this.$session.get('lastActivity')
        const currentTime = Date.now()
        const inactivityDuration = currentTime - lastActivity
        if (inactivityDuration > 120000) { // inactivity duration is 2 minutes
          this.stopInactivityTimer() // fire once — the condition stays true on every later tick
          this.$store.dispatch('logout')
          this.$router.push('/login').catch(() => {})
        }
      }, 1000) // Check every second/
    },
    stopInactivityTimer () {
      if (this.intervalId) {
        clearInterval(this.intervalId) // Clear the interval
      }
    }
  },
  beforeDestroy () {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },
  mounted () {
    this.automaticLogoutGet()
  }
}
</script>
<style scoped>
@media screen and (max-width: 399px) {

  .small_device_custom_spacing>a.v-btn,
  .small_device_custom_spacing>button.v-btn {
    min-width: 75px;
    font-size: 0.6rem;
  }
}

@media screen and (max-width: 379px) {

  .small_device_custom_spacing>a.v-btn,
  .small_device_custom_spacing>button.v-btn {
    min-width: 70px;
    font-size: 0.6rem;
  }
}

@media screen and (max-width: 359px) {

  .small_device_custom_spacing>a.v-btn,
  .small_device_custom_spacing>button.v-btn {
    min-width: 65px;
    font-size: 0.6rem;
  }
}

@media screen and (max-width: 329px) {

  .small_device_custom_spacing>a.v-btn,
  .small_device_custom_spacing>button.v-btn {
    min-width: 60px;
    font-size: 0.6rem;
  }
}

.fixbuttondesign {
  min-width: 110px !important;
}

@media only screen and (max-width: 575px) {
  .fixbuttondesign {
    min-width: 75px !important;
  }
}

@media only screen and (max-width: 575px) {

  .fixbuttondesign span,
  .moretextmsg {
    display: none;
  }

  .fixbuttondesign,
  .btnmsgbox {
    min-width: 60px !important;
    padding: 0 !important;
  }
}
</style>
<style>
/* Bottom nav on the (light) dashboard: match the dashboard layout instead of the
   default dark grey bar — white surface, subtle top divider, blue icons. */
.dash-bottom-nav.v-bottom-navigation {
  background-color: #ffffff !important;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.05) !important;
}
.dash-bottom-nav.v-bottom-navigation .v-btn,
.dash-bottom-nav.v-bottom-navigation .v-btn .v-icon {
  color: #0377e8 !important;
}
/* Bottom nav on the dark dashboard: match the dashboard's dark surface
   (#16202e) instead of the default grey, with white icons. */
.dash-bottom-nav--dark.v-bottom-navigation {
  background-color: #16202e !important;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.4) !important;
}
.dash-bottom-nav--dark.v-bottom-navigation .v-btn,
.dash-bottom-nav--dark.v-bottom-navigation .v-btn .v-icon {
  color: #ffffff !important;
}
</style>
